var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.user)?_c('dashboard',{attrs:{"user":_vm.user}}):_c('div',[_vm._v("In Todos, but user not defined")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }